import { ISiteAdminDataConnectSettings } from '~src/settings/types/ISiteAdminDataConnectSettings';

import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IUpdateSiteDataConnectSettingsForSiteAdminParams {
  id: string;
  siteAdminDataConnectSettings: ISiteAdminDataConnectSettings;
}

export interface IUpdateSiteDataConnectSettingsForSiteAdminResult {
}

export class UpdateSiteDataConnectSettingsForSiteAdminRequest extends Request<IUpdateSiteDataConnectSettingsForSiteAdminParams, IUpdateSiteDataConnectSettingsForSiteAdminResult> {
  constructor(params: IUpdateSiteDataConnectSettingsForSiteAdminParams) {
    super('updateSiteDataConnectSettingsForSiteAdmin', params);
  }
}
